import { API_IDS, REACT_QUERY_KEYS } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { useQuery } from '@tanstack/react-query';
import { container } from '../../DataDomain';
import { IGatewayService } from '../../application/services/GatewayService';
import { IApiPathManager } from '../../infrastructures/config/ApiPathManager';

export const useNewScreenQuery = (layout: string, screen: string, params: string, apiKey: string) =>
    useQuery({
        queryKey: [REACT_QUERY_KEYS.SCREEN_KEY, layout],
        queryFn: async () => {
            const apiPathManager = container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
            // console.log('SCREE ', apiPathManager.getPath(API_IDS.GATEWAY_SCREEN));
            // const appKey = process.env['NX_PUBLIC_WCP_APP_KEY'] || 'NX_PUBLIC_WCP_APP_KEY';
            const screenService = container.resolve<IGatewayService>(DI.SERVICES.IGatewayService);
            const screenComponents = await screenService.getGatewayScreen(apiKey, layout, screen, params);
            return screenComponents;
        },
    });
